export const PRELOAD_ERROR_EVENT = "vite:preloadError";
export const NO_OF_RETRIES = 3;
export const TRACES_SAMPLE_RATE = 0.2;

export const SENTRY_DSN =
  "https://13b17cb9c5e149389fe4d93bdec0605a@o1417853.ingest.sentry.io/6776415";

export enum SENTRY_ENV {
  PRODUCTION = "production",
  STAGING = "staging",
}
